<template>
  <div class="liveList">
    <mescroll-vue
      ref="mescroll"
      :down="mescrollDown"
      :up="mescrollUp"
      @init="mescrollInit"
    >
      <div class="common" v-if="startList.length > 0">
        <p class="commonTop">直播预告</p>
        <div class="commonContent">
          <ul>
            <li
              v-for="(item, index) in startList"
              :key="index"
              @click="goDetail(item)"
            >
              <Components type="live" :data="item"></Components>
            </li>
          </ul>
        </div>
      </div>
      <div class="common" v-if="endList.length > 0">
        <p class="commonTop">直播回放</p>
        <div class="commonContent">
          <ul>
            <li
              v-for="(item, index) in endList"
              :key="index"
              @click="goDetail(item)"
            >
              <Components type="live" :data="item"></Components>
            </li>
          </ul>
        </div>
      </div>
    </mescroll-vue>
  </div>
</template>

<script>
import Components from "./components/components.vue";
import MescrollVue from "mescroll.js/mescroll.vue";

export default {
  data() {
    return {
      teamInfoId: "",
      startList: [],
      endList: [],
      mescroll: null, // mescroll实例对象
      mescrollDown: {
        auto: false,
        callback: this.downCallback,
      },
      mescrollUp: {
        callback: this.upCallback, // 上拉回调,此处可简写; 相当于 callback: function (page, mescroll) { getListData(page); }
        //以下是一些常用的配置,当然不写也可以的.
        htmlNodata: "",
        page: {
          num: 0,
          size: 10,
        },
        noMoreSize: 5, //如果列表已无数据,可设置列表总数大于5才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
        empty: {
          //列表第一页无任何数据时,显示的空提示布局; 需配置warpId才显示
          // warpId: "xxid", //父布局的id (1.3.5版本支持传入dom元素)
          //icon: "./static/mescroll/mescroll-empty.png", //图标,默认null,支持网络图
          // warpId: "#list",
          // icon: "@/assets/img/index/noContent.png",
          //tip: "暂无其他头条内容",
        },
      },
    };
  },
  components: {
    Components,
    MescrollVue,
  },
  mounted() {
    this.teamInfoId = this.$route.query.teamInfoId;
  },
  methods: {
    mescrollInit(mescroll) {
      this.mescroll = mescroll;
    },
    downCallback() {
      this.mescroll.resetUpScroll();
    },
    upCallback(page, mescroll) {
      this.getListDataFromNet(page.num, page.size, mescroll);
    },
    getListDataFromNet(num, size, mescroll) {
      if (num == 1) {
        this.startList = [];
        this.endList = [];
      }
      var obj = {
       organizationid: this.teamInfoId,
        pageNum: num,
        pageSize: size,
      };
      this.$post(
        "/gart-common-api/api/scm/activity/queryLiveActivityListByOrganizationId",
        obj
      ).then((res) => {
        if (res.code == 1) {
            var data = res.data && res.data.rows ? res.data.rows : [];
            for (var i = 0; i < data.length; i++) {
              if (data[i].livestatus == 1000 || data[i].livestatus == 1001) {
                this.startList.push(data[i]);
              } else {
                this.endList.push(data[i]);
              }
            }
            this.$nextTick(() => {
              mescroll.endSuccess(data.length);
            });
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    goDetail(data) {

      this.$router.push({
        path: "/h5/course/live",
        query:{
         activityId: data.activityid,
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.liveList {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: hidden;
  .common {
    margin:16px;
    .commonTop {
      font-size: 16px;
      line-height: 22px;
      color: rgba(45, 45, 45, 1);
      font-weight: 600;
    }
    .commonContent {
      margin-top: 16px;
      li {
        padding-bottom: 24px;
      }
      li:not(:last-child) {
        margin-bottom: 16px;
        border-bottom: 1px solid rgba(234, 234, 234, 1);
      }
    }
  }
}
</style>